export default {
  employee: undefined,
  employees: [],
};
